import { render, staticRenderFns } from "./RecipeInputPriceForUserFood.vue?vue&type=template&id=1b536066&scoped=true"
import script from "./RecipeInputPriceForUserFood.vue?vue&type=script&lang=js"
export * from "./RecipeInputPriceForUserFood.vue?vue&type=script&lang=js"
import style0 from "./RecipeInputPriceForUserFood.vue?vue&type=style&index=0&id=1b536066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b536066",
  null
  
)

export default component.exports